import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => (
  <div className="home-page">
    <div className="home-hero">
      <h1>Affiliate Tracking SaaS</h1>
      <p className="home-lead">
        Effortlessly create, share, and track affiliate links. Get real-time analytics, conversion tracking, and powerful insights—all in one simple dashboard.
      </p>
      <div className="home-actions">
        <Link to="/login" className="btn btn-secondary">Login</Link>
        <Link to="/register" className="btn btn-primary">Get Started Free</Link>
      </div>
    </div>
    <div className="home-info">
      <h2>How It Works</h2>
      <ol>
        <li><strong>Sign up</strong> for a free account.</li>
        <li><strong>Create</strong> unique affiliate links for your campaigns.</li>
        <li><strong>Share</strong> your links and track performance in real time.</li>
        <li><strong>Analyze</strong> clicks, conversions, and revenue in your dashboard.</li>
      </ol>
      <h2>Pricing Tiers</h2>
      <div className="plan-table">
        <div className="plan-row plan-header">
          <div>Feature</div>
          <div>Free</div>
          <div>Pro <span className="plan-price">$9/mo<br/>or $90/yr</span></div>
        </div>
        <div className="plan-row">
          <div>Affiliate Links</div>
          <div>3</div>
          <div>Unlimited</div>
        </div>
        <div className="plan-row">
          <div>Clicks/Month</div>
          <div>1,000</div>
          <div>Unlimited</div>
        </div>
        <div className="plan-row">
          <div>Conversions/Month</div>
          <div>50</div>
          <div>Unlimited</div>
        </div>
        <div className="plan-row">
          <div>Dashboard</div>
          <div>Basic</div>
          <div>Advanced</div>
        </div>
        <div className="plan-row">
          <div>Export Data</div>
          <div>No</div>
          <div>Yes</div>
        </div>
        <div className="plan-row">
          <div>Priority Support</div>
          <div>No</div>
          <div>Yes</div>
        </div>
      </div>
      <div className="home-footer-cta">
        <span>Start for free, upgrade to Pro for just <strong>$9/month</strong> or <strong>$90/year</strong> (2 months free)!</span>
      </div>
    </div>
  </div>
);

export default Home;
